export const createBookingDateTimeString = (date: string, time: string) =>
	`${date}T${time}:00`;
